import { forgetPasswordSlice } from './forgetPassword/slice';
import { generalSlice } from './general/slice';
import { signUpSlice } from './signUp/slice';
import { authSlice } from './auth/slice';
import { workspaceSlice } from './workspace/slice';

export const reducer = {
  auth: authSlice.reducer,
  signUp: signUpSlice.reducer,
  general: generalSlice.reducer,
  workspace: workspaceSlice.reducer,
  forgetPassword: forgetPasswordSlice.reducer,
};